﻿import { createFileRoute, Outlet } from "@tanstack/react-router";
import { getGetUmbracoDeliveryApiV2SiteSettingsQueryOptions } from "#/_generated/umbraco/delivery-api/features/site-settings/site-settings.ts";
import type { SiteSettingsUmbPageContentResponseModel } from "#/_generated/umbraco/delivery-api/models";
import { getPublicEnv } from "#/_packages/umbrella/config/utils.ts";
import { SiteSettingsProvider } from "#/_packages/umbrella/hooks/site-settings-context";
import { getSearchSettings } from "#/app/features/search/api/get-search-settings.ts";

export const Route = createFileRoute("/_umbraco/_preview/umbraco")({
	loader: async (ctx) => {
		const [env, res, searchSettings] = await Promise.all([
			getPublicEnv(),
			ctx.context.queryClient.ensureQueryData(
				getGetUmbracoDeliveryApiV2SiteSettingsQueryOptions(),
			),
			getSearchSettings(),
		]);

		return {
			env,
			globalSiteSettings: res.data as SiteSettingsUmbPageContentResponseModel,
			searchSettings,
		};
	},

	component: () => {
		const { globalSiteSettings } = Route.useLoaderData();
		return (
			<SiteSettingsProvider settings={globalSiteSettings}>
				<Outlet />
			</SiteSettingsProvider>
		);
	},
});
